<template>
  <div v-if="isAdmin() || isAgent()">
    <b-form inline :id="`${getInputId}-form-${_uid}`" @submit.prevent="patchOasiceNumber" class="oasice-form">
      <label>N° Oasice</label>
        <b-form-input :id="`${getInputId}-${_uid}`"
                      type="text"
                      size="sm"
                      v-model="oasiceNumber"
                      :placeholder="getEnedisCaseOnGoing().oasiceNumber"
                      autocomplete="off"
                      :disabled="!isAdmin() && !isAgent()"
                      required>
        </b-form-input>
        <b-button text="Sauvegarder"
              type="submit"
              size="sm"
              variant="primary"
              id="save"
              :disabled="isAdmin() || isAgent()"><svg id="savePicto" viewBox="0 0 24.42 20" style="enable-background:new 0 0 24.42 20;" xml:space="preserve"><path class="st3" d="M24.15,6.71c-0.31-0.41-0.85-0.67-1.41-0.67h-1.31V3.82c0-0.9-0.71-1.63-1.58-1.63h-8.99l-1.3-1.85
      C9.42,0.13,9.17,0,8.91,0H1.72C0.81,0,0.07,0.74,0.07,1.65v16.33c-0.13,0.44-0.08,0.91,0.17,1.3C0.53,19.73,1.04,20,1.61,20h16.95
      c1.14,0,1.44-0.91,1.59-1.35l4.2-10.73C24.48,7.5,24.41,7.06,24.15,6.71z M8.48,1.62l1.3,1.85c0.15,0.22,0.4,0.34,0.66,0.34l9.36,0
      v2.22H5.8c-1.13,0-1.47,1.01-1.59,1.35L1.7,13.78L1.72,1.62H8.48z M18.62,18.09c-0.05,0.14-0.08,0.23-0.11,0.28l-16.88,0L5.73,7.94
      C5.78,7.79,5.82,7.7,5.85,7.66h16.87L18.62,18.09z"/><path class="st3" d="M11.64,17.19c0.07,0.08,0.16,0.13,0.26,0.18c0.1,0.04,0.2,0.06,0.31,0.06c0.11,0,0.21-0.02,0.31-0.06
      c0.1-0.04,0.19-0.1,0.26-0.18l2.29-2.29c0.32-0.32,0.32-0.83,0-1.15c-0.32-0.32-0.83-0.32-1.15,0l-0.91,0.91V9.42
      c0-0.45-0.36-0.81-0.81-0.81c-0.45,0-0.81,0.36-0.81,0.81v5.23l-0.94-0.94c-0.32-0.32-0.83-0.32-1.15,0
      c-0.32,0.32-0.32,0.83,0,1.15L11.64,17.19z"/></svg>Sauvegarder</b-button>
      <!-- Alert -->
      <ValidationErrorAlert :form-error-list="oasiceNumberFormError || []"/>
    </b-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'OasiceNumberInputType',
  props: {
  },
  data() {
    return {
      oasiceNumber: '',
      oasiceNumberFormError: null,
    };
  },
  computed: {
    ...mapGetters([
    ]),
    getInputId() {
      return 'oasice-number-input';
    },
  },
  methods: {
    ...mapGetters([
      'getEnedisCaseOnGoing',
      'isAdmin',
      'isAgent',
    ]),
    patchOasiceNumber(event) {
      // Only admins and agents can patch a case
      if (!this.isAdmin() && !this.isAgent()) {
        return;
      }

      this.oasiceNumberFormError = [];

      let formData = {
        oasiceNumber: this.oasiceNumber,
      };

      axios.patch(`enedis-cases/${this.getEnedisCaseOnGoing().id}`, formData)
          .then((response) => {
            // Show success toast
            const toast = {
              show: true,
              message: 'Numéro Oasice modifier avec succès !',
              variant: 'success',
              duration: 3000,
            };
            this.$store.commit('setGlobalToaster', toast);
            this.$store.commit('setEnedisCaseOnGoing', response.data);
          })
          .catch((error) => {
            this.oasiceNumberFormError = error.response.data.oasiceNumber;
            console.error(error.message);
          });
    },
  },
  mounted() {
    this.oasiceNumber = this.getEnedisCaseOnGoing().oasiceNumber;
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.oasice-form {
  background-color: white;
  padding: 15px 30px;
  display: flex;
  border-radius: 5px;
  flex-direction: row;
  justify-content: space-between;
}
  .oasice-number-input {
    max-width: 375px;
  }
  .oasice-number-input-legend {
    font-size: 12px;
    font-style: italic;
  }

#save {
  background-color: #005EB8;
  border-color: #005EB8;
  color: white;
  text-transform: uppercase;
  font-weight: 700;
  padding: 5px 25px;
  display: flex;
  flex-direction: row;
  align-items: center;

  #savePicto {
    fill: white;
    width: 19px;
    margin-right: 10px
  }

  &:hover,
  &:focus,
  &:active {
    background-color: white;
    color: #005EB8;

    #savePicto {
      fill: #005EB8 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form/OasiceNumberInputType.vue